import React from "react";
import { Link } from "react-router-dom";
import { Avatar } from "@mui/material";
import "./logo.scss";
import { useSelector } from "react-redux";
import { getOrg } from "redux/selectors/getOrg";
import _ from 'lodash'
import { ADMIN_HOME_PATH } from "helpers/url";

// Логотип организации. Без логотипа (или если картинка не загрузилась) — первая буква названия.
// org — свежие данные организации (если есть), иначе берём из авторизованного пользователя.
// compact — только значок, для свёрнутого сайдбара.
const Logo = ({ org: orgProp, compact = false }) => {
  const member = useSelector(getOrg);
  const org = orgProp || _.get(member, 'org')
  const name = org?.name || ''
  const size = compact ? 32 : 44

  return <div className="logo">
    <Link to={ADMIN_HOME_PATH} className="gap-2" title={name}>
      <Avatar
        className="logo-avatar"
        variant="rounded"
        src={org?.logo || undefined}
        alt={name}
        sx={{
          width: size,
          height: size,
          bgcolor: org?.logo ? 'transparent' : 'primary.main',
          '& img': { objectFit: 'contain' },
        }}
      >
        {name.charAt(0).toUpperCase()}
      </Avatar>
      {!compact && <span className="logo-label">{name}</span>}
    </Link>
  </div>
}
export default Logo;
